import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "next/navigation";
import { fetchThreadsList } from "@store/features/threads/threadSlice";
import { type AppDispatch, type RootState } from "@store/index";

/**
 * Loads the thread list when the inbox sidebar is opened and data is not yet available.
 */
export function useFetchThreadsOnSidebarOpen(): void {
  const dispatch = useDispatch<AppDispatch>();
  const params = useParams<{ subdomain: string | undefined }>();
  const isOpen = useSelector(
    (state: RootState) => state.sideNavigation.right.isOpen,
  );
  const schema = useSelector(
    (state: RootState) => state.sideNavigation.right.schema,
  );
  const hasThreadItems = useSelector(
    (state: RootState) => state.threads.items.length > 0,
  );
  const listLoading = useSelector(
    (state: RootState) => state.threads.listLoading,
  );

  useEffect(() => {
    if (!params.subdomain || !isOpen || schema !== "THREAD_LIST") return;
    if (listLoading || hasThreadItems) return;

    void dispatch(fetchThreadsList());
  }, [
    dispatch,
    params.subdomain,
    isOpen,
    schema,
    hasThreadItems,
    listLoading,
  ]);
}
